@let hasARAT = assessmentChartDataSets()?.ARAT?.length ?? 0 > 0; 
@let hasBBS = assessmentChartDataSets()?.BBS?.length ?? 0 > 0; 
@let hasBBT = assessmentChartDataSets()?.BBT?.length ?? 0 > 0; 
@let hasFGA = assessmentChartDataSets()?.FGA?.length ?? 0 > 0; 
@let hasNHPT = assessmentChartDataSets()?.NHPT?.length ?? 0 > 0; 
@let hasTUG = assessmentChartDataSets()?.TUG?.length ?? 0 > 0; 

<div class="container">
  <div class="top-container">
    <h1>Behandlungsverlauf</h1>
  </div>

  @if (hasARAT) {
    <div class="bar-container">
      <div class="chart-header">
        <h2>{{ aratInfo.shortName }}</h2>
        <div class="description" [innerHTML]="aratInfo.reportDescription"></div>
        <h4 class="warn"><mat-icon>warning_amber</mat-icon>Achtung: Die folgenden Prozente geben die Erfüllung an, nicht die Schädigung!</h4>
      </div>
      <app-line-chart-multi
        [patient]="patientsService.patient()!"
        [data]="assessmentChartDataSets()?.ARAT"
        [dataFull]="assessmentChartDataSets"
        label="Erfüllung in %"
        chartId="arat"
        class="bar-item"></app-line-chart-multi>
    </div>
    <!-- <h4>Liste der ARAT Befundungen</h4> -->
    <app-assessment-table-sub
      [printMode]="true"
      type="ARAT"
      [assessmentList]="assessmentList"></app-assessment-table-sub>
  }

  @if (hasBBS) {
    @if(hasARAT) {
      <div class="page-break"></div>
    }
    <div class="bar-container">
      <div class="chart-header">
        <h2>{{ bbsInfo.shortName }}</h2>
        <div class="description" [innerHTML]="bbsInfo.reportDescription"></div>
        <h4 class="warn"><mat-icon>warning_amber</mat-icon>Achtung: Die folgenden Prozente geben die Erfüllung an, nicht die Schädigung!</h4>
      </div>
      <app-line-chart-single
        [data]="assessmentChartDataSets()?.BBS"
        [dataFull]="assessmentChartDataSets"
        label="Erfüllung in %"
        chartId="bbs"
        class="bar-item"></app-line-chart-single>
    </div>
    <app-assessment-table-sub
      [printMode]="true"
      type="BBS"
      [assessmentList]="assessmentList"></app-assessment-table-sub>
  }

  @if (hasBBT) {
    @if(hasARAT || hasBBS) {
      <div class="page-break"></div>
    }
    <div class="bar-container">
      <div class="chart-header">
        <h2>{{ bbtInfo.shortName }}</h2>
        <div class="description" [innerHTML]="bbtInfo.reportDescription"></div>
        <h4 class="warn"><mat-icon>warning_amber</mat-icon>Achtung: Die folgenden Prozente geben die Erfüllung an, nicht die Schädigung!</h4>
      </div>
      <app-line-chart-multi
        [patient]="patientsService.patient()!"
        [data]="assessmentChartDataSets()?.BBT"
        [dataFull]="assessmentChartDataSets"
        label="Erfüllung in %"
        chartId="bbt"
        class="bar-item"></app-line-chart-multi>
    </div>
    <app-assessment-table-sub
      [printMode]="true"
      type="BBT"
      [assessmentList]="assessmentList"></app-assessment-table-sub>
  }
  @if (hasFGA) {
    @if(hasARAT || hasBBT || hasBBS) {
      <div class="page-break"></div>
    }
    <div class="bar-container">
      <div class="chart-header">
        <h2>{{ fgaInfo.shortName }}</h2>
        <div class="description" [innerHTML]="fgaInfo.reportDescription"></div>
        <h4 class="warn"><mat-icon>warning_amber</mat-icon>Achtung: Die folgenden Prozente geben die Erfüllung an, nicht die Schädigung!</h4>
      </div>
      <app-line-chart-single
        [data]="assessmentChartDataSets()?.FGA"
        [dataFull]="assessmentChartDataSets"
        label="Erfüllung in %"
        chartId="fga"
        class="bar-item"></app-line-chart-single>
    </div>
    <app-assessment-table-sub
      [printMode]="true"
      type="FGA"
      [assessmentList]="assessmentList"></app-assessment-table-sub>
  }

  @if (hasNHPT) {
    @if(hasARAT || hasBBT || hasBBS || hasFGA) {
      <div class="page-break"></div>
    }
    <div class="bar-container">
      <div class="chart-header">
        <h2>{{ nhptInfo.shortName }}</h2>
        <div class="description" [innerHTML]="nhptInfo.reportDescription"></div>
        <h4 class="warn"><mat-icon>warning_amber</mat-icon>Achtung: Die folgenden Prozente geben die Erfüllung an, nicht die Schädigung!</h4>
      </div>
      <app-line-chart-nhpt
        [patient]="patientsService.patient()!"
        [data]="assessmentChartDataSets()?.NHPT"
        [dataFull]="assessmentChartDataSets"
        label="Erfüllung in %"
        chartId="nhpt"
        class="bar-item"></app-line-chart-nhpt>
    </div>
    <app-assessment-table-sub
      [printMode]="true"
      type="NHPT"
      [assessmentList]="assessmentList"></app-assessment-table-sub>
  }

  @if (hasTUG) {
    @if(hasARAT || hasBBT || hasBBS || hasFGA || hasNHPT) {
      <div class="page-break"></div>
    }
    <div class="bar-container">
      <div class="chart-header">
        <h2>{{ tugInfo.shortName }}</h2>
        <div class="description" [innerHTML]="tugInfo.reportDescription"></div>
        <h4 class="warn"><mat-icon>warning_amber</mat-icon>Achtung: Die folgenden Prozente geben die Erfüllung an, nicht die Schädigung!</h4>
      </div>
      <app-line-chart-single
        [data]="assessmentChartDataSets()?.TUG"
        [dataFull]="assessmentChartDataSets"
        label="Erfüllung in %"
        chartId="tug"
        class="bar-item"></app-line-chart-single>
    </div>
    <app-assessment-table-sub
      [printMode]="true"
      type="TUG"
      [assessmentList]="assessmentList"></app-assessment-table-sub>
  }
</div>
